import $ from 'jquery'

$( document ).ready( function() {
	// handle double click
	$( '.esh-dblclick[ondblclick][onclick]:not([data-dblclick])' ).each(function( index, element ) {
		$( element ).attr( 'onclick', 
			'event.preventDefault( );' +
        	'event.stopImmediatePropagation( );' +
			'console.log( "cleared timeout in click", event.target.clickTimeout );' +
			'clearTimeout( event.target.clickTimeout );' +
			'event.target.clickTimeout = setTimeout( function( event ) {' +
				'console.log( "handling click" );' +
				$( element ).attr( 'onclick' ) +
			'}, 300, event );')
		.attr( 'data-dblclick', '1' )
		.dblclick( event, function( e ) {
			console.log( 'handling dblclick' )
			console.log( 'cleared timeout in dblclick', e.target.clickTimeout )
			clearTimeout( e.target.clickTimeout )
		} )
	} )
} )



// WEBPACK FOOTER //
// ./src/components/dblclick/index.js